import { Injectable } from '@angular/core';
import { ElementApiService, PrimaryKeySetting } from 'dbweb-core';
const ElementBillClone = 'billclone';
interface GetClonePKParam {
	OldSignPK: string;
	EleName: string;
}
interface BillCloneParam {
	EleName: string;
	OldSignPK: string;
	NewPK: { [key: string]: string };
}
interface BillCloneResult {
	Ok: boolean;
	Error: string;
}
@Injectable({
	providedIn: 'root'
})
export class BillCloneBackfaceService {
	constructor(private api: ElementApiService) {}
	getClonePK(param: GetClonePKParam) {
		return this.api.get<PrimaryKeySetting[]>(ElementBillClone, 'get-clone-pk', param);
	}
	billClone(param: BillCloneParam) {
		return this.api.post<BillCloneResult>(ElementBillClone, 'bill-clone', param);
	}
}
